const categories = [
  { icon: 'ri-heart-pulse-line', label: '恋爱甜宠', count: '2,380部', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-sword-line', label: '热血战斗', count: '1,850部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-magic-line', label: '奇幻冒险', count: '2,120部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-ghost-line', label: '悬疑惊悚', count: '960部', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-emotion-laugh-line', label: '搞笑日常', count: '1,540部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-user-heart-line', label: 'BL/GL', count: '1,280部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-building-2-line', label: '职场商战', count: '720部', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-aliens-line', label: '科幻未来', count: '890部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-landscape-line', label: '古风国漫', count: '1,650部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            按题材快速找到你想看的漫画，韩漫日漫国漫一应俱全
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {categories.map((cat, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-center gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <span className={`w-12 h-12 rounded-lg flex items-center justify-center shrink-0 ${cat.color}`}>
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.label}
                </p>
                <p className="text-xs text-foreground-500 whitespace-nowrap">{cat.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}